import styled from 'styled-components';
import { colors } from 'components/Theme';
import { asRem } from 'utils';
import { RoundedBox } from 'Component';
import { breakpoints } from 'Theme';

export default styled(RoundedBox)`
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  background-color: ${colors.white.c500};
  margin-top: ${asRem(12)};
  margin-bottom: ${asRem(8)};
  text-align: center;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.4);
  padding-bottom: ${asRem(24)};
  position: relative;
  outline: 1px solid transparent;

  @media (min-width: ${breakpoints.md}) {
    padding-bottom: ${asRem(30)};
  }

  &:hover {
    outline: 1px solid ${colors.blueGrey.c500};
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.8);

    button.mime-elements-button {
      background-color: ${colors.blue.c500};
      border-color: ${colors.blue.c500};
    }
  }

  .badge {
    background-color: ${colors.blueGrey.c500};
    width: 100%;
    height: ${asRem(40)};
    justify-content: center;
    align-items: center;
    display: flex;
    position: absolute;
    border: 1px solid ${colors.blueGrey.c500};
    top: 0;

    p {
      color: ${colors.white.c500};
      margin-top: ${asRem(16)};
      letter-spacing: ${asRem(1.1)};
    }
  }

  h4 {
    margin-bottom: ${asRem(8)};

    @media (min-width: ${breakpoints.md}) {
      margin-bottom: ${asRem(16)};
    }
  }

  .image {
    margin-top: ${asRem(32)};
    width: ${asRem(133)};
    height: ${asRem(108)};
    align-self: center;

    @media (min-width: ${breakpoints.md}) {
      margin-top: ${asRem(20)};
      width: ${asRem(223)};
      height: ${asRem(180)};
    }
  }

  button.mime-elements-button {
    background-color: ${colors.blueGrey.c500};
    border-color: ${colors.blueGrey.c500};
    letter-spacing: ${asRem(1)};
  }
`;
